import React, { FC, useEffect, useRef } from 'react';
import {
  Dropdown,
  Typography,
  Sizes,
  TextBoldness,
  getClassNameFactory,
} from '@dcl/ui';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import './FileDownloadSelector.css';
import { IFileDownloadSelectorProps } from '../../../FileDownloadExperienceSearchResultDekstop/types';

export const FileDownloadSelector: FC<IFileDownloadSelectorProps> = (props) => {
  const {
    fileDropdownList,
    filePlaceholderText,
    fileDropdownLabel,
    fileOnDropdownValueChange,
    fileMaximumVisibleItem,
    fileDropdownValue,
  } = props;
  const filedropdownRef = useRef<Dropdown>();
  const getClassName = getClassNameFactory(FileDownloadSelector.displayName);

  useEffect(() => {
    filedropdownRef?.current?.setState({ value: fileDropdownValue });
  }, [fileDropdownValue]);

  return (
    <div>
      <Typography
        type={Sizes.XXTRASMALL}
        boldness={TextBoldness.Medium}
        tag={TypographyTags.P}
      >
        {fileDropdownLabel}
      </Typography>

      <Dropdown
        ref={(element) => (filedropdownRef.current = element!)}
        maxVisibleItems={fileMaximumVisibleItem}
        block={true}
        items={fileDropdownList}
        placeholder={filePlaceholderText}
        onValueChanged={(value) => fileOnDropdownValueChange(value as string)}
        withCheckmark
        className={getClassName({ descendantName: 'customDropdown' })}
        value={fileDropdownValue}
      />
    </div>
  );
};

FileDownloadSelector.displayName = 'FileDownloadSelector';
